import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './PacientesData.css';
import baseURL from '../../url';
import NewPaciente from './NewPaciente';

export default function PacientesData() {
    const [pacientes, setPacientes] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [paciente, setPaciente] = useState({});
    const [search, setSearch] = useState('');

    useEffect(() => {
        cargarPacientes();
    }, []);

    const cargarPacientes = () => {
        fetch(`${baseURL}/pacientesGet.php`)
            .then(res => res.json())
            .then(data => setPacientes(data.pacientes || []))
            .catch(err => console.error(err));
    };

    const eliminarPaciente = (id) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                const formData = new FormData();
                formData.append('id', id);

                fetch(`${baseURL}/pacienteDelete.php`, {
                    method: 'POST',
                    body: formData,
                })
                .then(res => res.json())
                .then(data => {
                    if(data.error){
                        Swal.fire('Error', data.error, 'error');
                    } else {
                        Swal.fire('¡Eliminado!', data.mensaje, 'success');
                        cargarPacientes();
                    }
                })
                .catch(err => Swal.fire('Error', err.message, 'error'));
            }
        });
    };

    const abrirModal = (item = {}) => {
        setPaciente(item);
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setPaciente({});
        setModalVisible(false);
    };

    const pacientesFiltrados = pacientes.filter(p =>
        p.nombre.toLowerCase().includes(search.toLowerCase()) ||
        p.email?.toLowerCase().includes(search.toLowerCase()) ||
        p.telefono?.includes(search)
    );

    return (
        <div className="pacientes-container">
            <ToastContainer />
            <div className="pacientes-header">
                <div className="pacientes-search">
                    <input
                        type="text"
                        placeholder="Buscar paciente..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                    <button className="btn btn-add" onClick={() => abrirModal()}>Nuevo Paciente</button>
                </div>
            </div>

            {modalVisible && (
                <NewPaciente paciente={paciente} cerrarModal={cerrarModal} recargar={cargarPacientes} />
            )}

            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Teléfono</th>
                            <th>Email</th>
                            <th>Sexo</th>
                            <th>Categoría</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pacientesFiltrados.map(p => (
                            <tr key={p.id}>
                                <td>{p.nombre}</td>
                                <td>{p.telefono}</td>
                                <td>{p.email}</td>
                                <td>{p.sexo}</td>
                                <td>{p.categoria}</td>
                                <td>
                                    <button className="editar" onClick={() => abrirModal(p)}>
                                        <FontAwesomeIcon icon={faEdit} />
                                    </button>
                                    <button className="eliminar" onClick={() => eliminarPaciente(p.id)}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
